import React, { useState, useEffect } from 'react';
import {
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
  CardActions,
  IconButton,
  TextField,
  Button,
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import axios from 'axios';
import BASE_URL from '../config';
//const BASE_URL = 'http://localhost:5000'; // Update with your API base URL

const ContactDetails = () => {
  const [contacts, setContacts] = useState([]);
  const [editingContact, setEditingContact] = useState(null);

  // Fetch contact details on page load
  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/contact_details`);
      const data = response.data;
      //setContacts(response.data);
      setContacts(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error fetching contacts:', error);
    }
  };

  const handleEdit = async (id) => {
    try {
      await axios.put(`${BASE_URL}/api/contact_details/${id}`, editingContact);
      setEditingContact(null);
      fetchContacts();
    } catch (error) {
      console.error('Error updating contact:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${BASE_URL}/api/contact_details/${id}`);
      fetchContacts();
    } catch (error) {
      console.error('Error deleting contact:', error);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography variant="h4" sx={{ textAlign: 'center', mb: 4 }}>
        Footer Details
      </Typography>
      <Grid container spacing={3}>
        {contacts.map((contact) => (
          <Grid item xs={12} sm={6} key={contact.contact_id}>
            <Card>
              <CardContent>
                {editingContact?.contact_id === contact.contact_id ? (
                  <>
                    <TextField
                      label="Mobile Number"
                      fullWidth
                      value={editingContact.mobile_number}
                      onChange={(e) =>
                        setEditingContact({ ...editingContact, mobile_number: e.target.value })
                      }
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      label="WhatsApp Number"
                      fullWidth
                      value={editingContact.whatsapp_number}
                      onChange={(e) =>
                        setEditingContact({ ...editingContact, whatsapp_number: e.target.value })
                      }
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      label="Email"
                      fullWidth
                      value={editingContact.email}
                      onChange={(e) =>
                        setEditingContact({ ...editingContact, email: e.target.value })
                      }
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      label="Facebook Link"
                      fullWidth
                      value={editingContact.facebook_link}
                      onChange={(e) =>
                        setEditingContact({ ...editingContact, facebook_link: e.target.value })
                      }
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      label="YouTube Link"
                      fullWidth
                      value={editingContact.youtube_link}
                      onChange={(e) =>
                        setEditingContact({ ...editingContact, youtube_link: e.target.value })
                      }
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      label="Instagram Link"
                      fullWidth
                      value={editingContact.instagram_link}
                      onChange={(e) =>
                        setEditingContact({ ...editingContact, instagram_link: e.target.value })
                      }
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      label="Twitter Link"
                      fullWidth
                      value={editingContact.twitter_link}
                      onChange={(e) =>
                        setEditingContact({ ...editingContact, twitter_link: e.target.value })
                      }
                      sx={{ mb: 2 }}
                    />
                  </>
                ) : (
                  <>
                    <Typography variant="h6">Mobile: {contact.mobile_number}</Typography>
                    <Typography>WhatsApp: {contact.whatsapp_number}</Typography>
                    <Typography>Email: {contact.email}</Typography>
                    <Typography>Facebook: {contact.facebook_link}</Typography>
                    <Typography>YouTube: {contact.youtube_link}</Typography>
                    <Typography>Instagram: {contact.instagram_link}</Typography>
                    <Typography>Twitter: {contact.twitter_link}</Typography>
                  </>
                )}
              </CardContent>
              <CardActions>
                {editingContact?.contact_id === contact.contact_id ? (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleEdit(contact.contact_id)}
                  >
                    Save
                  </Button>
                ) : (
                  <IconButton onClick={() => setEditingContact(contact)}>
                    <Edit />
                  </IconButton>
                )}
                <IconButton onClick={() => handleDelete(contact.contact_id)}>
                  <Delete />
                </IconButton>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ContactDetails;
